import { tint } from 'polished'
import styled from 'styled-components'

const ModalExplainer = styled.aside(
  ({ theme }) => `
  background-color: ${tint(0.9, theme.colors.state.warning)};
  padding: 16px;
  border-radius: ${theme.radii.xxlarge};

  font-size: ${theme.fontSizes.smaller};
  line-height: ${theme.lineHeights[9]};
  color: ${theme.colors.foreground.secondary[3]};
`
)

export default ModalExplainer
